import { TextStyle } from '@superops/ui-design-system';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const Wrapper = styled.div`
  background: ${(props) => props?.color ?? 'none'};
  border-radius: 5px;
  width: fit-content;
  padding: 4px 8px;
  font-weight: 500;
`;

function BadgeCell(props) {
  const { data, meta = [], field } = props;
  return (
    <Wrapper color={meta?.[field?.name]?.[data || 0]?.colorCode}>
      {data || (
        <TextStyle variation="subdued">
          <FormattedMessage id="app.noData.message" />
        </TextStyle>
      )}
    </Wrapper>
  );
}

export default BadgeCell;
